import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { TranslocoModule } from '@jsverse/transloco';
import { AuthService } from 'src/core/services/auth.service';
import { ThemeService } from 'src/core/services/thememanager.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login-failed',
  imports: [TranslocoModule],
  templateUrl: './login-failed.component.html',
  styleUrl: './login-failed.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LoginFailedComponent {
    theme: string;

    constructor(private msalService: MsalService, private authService: AuthService, private themeService: ThemeService) { }
  
    ngOnInit(): void {
      this.themeService.currentTheme$.subscribe(theme => {
        this.theme = theme;
      });
    }

    onLoginClick = () => {
      try {
        if (!this.msalService || !this.msalService.instance) {
          console.error('MSAL service or instance is not available');
          return;
        }
        this.msalService.instance.loginRedirect({
          redirectStartPage: this.authService.redirectUrl || '/',
          scopes: [...environment.apiConfig.scopes]
        });
      } catch (error) {
        console.error('Error during login redirect:', error);
      }
    }

}
